import React from 'react';
import { CheckSquare, Plus, Calendar, User } from 'lucide-react';

const Tasks = () => {
    const tasks = [
        { id: 1, title: 'Finalize Series A Pitch Deck', due: 'Today', assignee: 'Alex', priority: 'High' },
        { id: 2, title: 'Review Legal Incorporation Docs', due: 'Tomorrow', assignee: 'AI Agent', priority: 'Medium' },
        { id: 3, title: 'Set up Stripe Payments', due: 'Next Week', assignee: 'Alex', priority: 'High' },
        { id: 4, title: 'Approve Marketing Copy', due: 'Nov 24', assignee: 'AI Agent', priority: 'Low' },
    ];

    return (
        <div className="max-w-5xl mx-auto">
            <div className="flex justify-between items-center mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-slate-900">Task Manager</h1>
                    <p className="text-slate-500">Track your autonomous agents and personal to-dos.</p>
                </div>
                <button className="btn btn-primary">
                    <Plus size={18} className="mr-2" /> Add Task
                </button>
            </div>

            <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
                <table className="w-full text-left">
                    <thead className="bg-slate-50 border-b border-slate-200">
                        <tr>
                            <th className="p-4 text-xs font-bold text-slate-500 uppercase">Task Name</th>
                            <th className="p-4 text-xs font-bold text-slate-500 uppercase">Due Date</th>
                            <th className="p-4 text-xs font-bold text-slate-500 uppercase">Assignee</th>
                            <th className="p-4 text-xs font-bold text-slate-500 uppercase">Priority</th>
                            <th className="p-4 text-xs font-bold text-slate-500 uppercase text-right">Status</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {tasks.map((task) => (
                            <tr key={task.id} className="hover:bg-slate-50 transition-colors group">
                                <td className="p-4 font-medium text-slate-900 flex items-center gap-3">
                                    <CheckSquare className="text-slate-300 hover:text-primary cursor-pointer" size={18} />
                                    {task.title}
                                </td>
                                <td className="p-4 text-slate-500 text-sm">
                                    <div className="flex items-center gap-2"><Calendar size={14} /> {task.due}</div>
                                </td>
                                <td className="p-4 text-slate-500 text-sm">
                                    <div className="flex items-center gap-2"><User size={14} /> {task.assignee}</div>
                                </td>
                                <td className="p-4">
                                    <span className={`text-xs px-2 py-1 rounded-full font-medium ${task.priority === 'High' ? 'bg-red-50 text-red-600' :
                                        task.priority === 'Medium' ? 'bg-yellow-50 text-yellow-600' : 'bg-slate-100 text-slate-600'
                                        }`}>
                                        {task.priority}
                                    </span>
                                </td>
                                <td className="p-4 text-right">
                                    <span className="px-3 py-1 border border-slate-200 rounded text-xs font-medium text-slate-600">In Progress</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Tasks;
